import * as Showdown from 'showdown';

export function showdownMarkdownClassesExtension(opts?: {
  imageClass?: string;
  textClass?: string;
  aiImageClass?: string;
  aiImageBucketHint?: string;
}): Showdown.ShowdownExtension {
  const imageClass = opts?.imageClass || 'md-img';
  const textClass = opts?.textClass || 'md-text';
  const aiImageClass = opts?.aiImageClass || 'ai-image';
  const aiHint = (opts?.aiImageBucketHint || 'media.geniousvision.com').toLowerCase();

  return {
    type: 'output',
    filter: (html: string) => {
      try {
        // Browser-safe path (best)
        if (typeof DOMParser !== 'undefined') {
          const doc = new DOMParser().parseFromString(html, 'text/html');

          doc.querySelectorAll('img').forEach((img) => {
            img.classList.add(imageClass);

            const alt = (img.getAttribute('alt') || '').toLowerCase();
            const src = (img.getAttribute('src') || '').toLowerCase();
            const isAi =
              alt.includes('ai-image') ||
              alt.includes('ai image') ||
              alt === 'ai' ||
              alt.includes('generated') ||
              (aiHint && src.includes(aiHint));

            if (isAi) img.classList.add(aiImageClass);
          });

          doc.querySelectorAll('p, li, blockquote, h1, h2, h3, h4, h5, h6, figcaption')
            .forEach((el) => el.classList.add(textClass));

          return doc.body.innerHTML;
        }

        // SSR / no-DOM fallback (simple regex)
        // Note: This is intentionally conservative.
        return html
          .replace(/<img(?![^>]*\bclass=)/gi, `<img class="${imageClass}"`)
          .replace(/<img([^>]*\bclass=["'])([^"']*)(["'])/gi, `<img$1$2 ${imageClass}$3`)
          .replace(/<(p|li|blockquote|h[1-6]|figcaption)>/gi, `<$1 class="${textClass}">`);
      } catch {
        return html;
      }
    }
  };
}
